module.exports = __webpack_public_path__ + "img/index-customer-service.7e2f9c6.svg";